import React, { useEffect } from 'react';
import en_logo from '../assets/jave-time-logo-final-english.svg'
import $ from "jquery";
import ar_logo from '../assets/ar-javatime-logo.svg'
import { BrowserRouter as Link, NavLink, useLocation, useHistory } from "react-router-dom"

function Navbar({ isArabic, actvieNav, setIsArabic }) {
    let location = useLocation();
    const history = useHistory()
    useEffect(() => {
        $(window).on('scroll', function () {
            var $nav = $('.nav-mobile');
            $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
        });
    }, [])

    const toggleMenu = () => {
        $('.menu-toggle, nav, .nav .nav-links').toggleClass('on');
        if ($('.menu-toggle').hasClass('on')) {
            $('.nav-mobile').removeClass('transparent')
        }
    }

    return (
        <React.Fragment>
            {/* <!-- mobile nav --> */}
            <nav className="nav nav-mobile justify-content-center pb-3">
                <a className="navbar-brand m-0" href="#" onClick={() => history.push('/') }>
                    <img src={(isArabic) ? ar_logo : en_logo} width="100" className={`${(location.pathname === '/') ? 'd-none' : ''}`} /></a>
                <div className="menu-toggle" onClick={() => toggleMenu()}>
                    <div className="one"></div>
                    <div className="two"></div>
                    <div className="three"></div>
                </div>
                <div className="nav-links col-md-6 p-0">
                    <img src={(isArabic) ? ar_logo : en_logo} width="180" className="" />
                    <ul className="navbar-nav">
                        <li className="nav-item py-2">
                            <NavLink to="/" exact className="nav-link px-4">{actvieNav[0]}</NavLink>
                        </li>
                        <li className="nav-item py-2">
                            <NavLink className="nav-link px-4" exact to="/branches">{actvieNav[1]}</NavLink>
                        </li>
                        <li className="nav-item py-2">
                            <NavLink className="nav-link px-4" exact to="/products">{actvieNav[2]}</NavLink>
                        </li>
                        <li className="nav-item py-2">
                            <NavLink className="nav-link px-4" exact to="/contactus">{actvieNav[3]}</NavLink>
                        </li>
                        <li className="nav-item py-2">
                            <a className="nav-link px-4" href="tel:0502662288">{actvieNav[4]}</a>
                        </li>
                    </ul>
                    <a className="nav-link lang" href="#" role="button"
                        aria-haspopup="true" aria-expanded="false" onClick={() => setIsArabic(!isArabic)} >
                        {(isArabic) ? "EN" : "عربي"}
                    </a>
                </div>
            </nav>
            {/* <!-- desktop nav --> */}
            <nav className="navbar navbar-expand-lg d-none d-lg-flex mx-auto navbar-index pt-4 pr-0 pl-0" >
                {(location.pathname !== '/') ? <a className="navbar-brand" href="#"><img src={(isArabic) ? ar_logo : en_logo} width="130" className="d-inline-block" /></a> : ''}
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink to="/" exact className="nav-link px-4"><span>{actvieNav[0]}</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link px-4" exact to="/branches"><span>{actvieNav[1]}</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link px-4" exact to="/products"><span>{actvieNav[2]}</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link px-4" exact to="/contactus"><span>{actvieNav[3]}</span></NavLink>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link px-4" href="tel:0502662288"><span>{actvieNav[4]}</span></a>
                        </li>
                    </ul>
                </div>
                <div className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {(isArabic) ? "عربي" : "EN"}
                    </a>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                        <a className="dropdown-item" href="#"
                            onClick={() => setIsArabic(!isArabic)}
                        > {(isArabic) ? "EN" : "عربي"}</a>
                    </div>
                </div>
            </nav >
        </React.Fragment>
    )
}
export default Navbar;
